<script>
export default {
  methods: {
    isEverythingChecked(items) {
      return (
        items.filter(item => {
          const numberUncheckedItems = item.items.filter(
            ti => !ti.checked,
          ).length
          return !item.checked || numberUncheckedItems > 0
        }).length === 0
      )
    },

    isEverythingUnchecked(items) {
      return (
        items.filter(item => {
          const numberCheckedItems = item.items.filter(ti => ti.checked).length
          return item.checked || numberCheckedItems > 0
        }).length === 0
      )
    },

    getSelections() {
      const items = []
      const parentId =
        this.checkedOption === 'filterByAirline' ? 'airlineId' : 'masterModelId'
      const childId =
        this.checkedOption === 'filterByAirline' ? 'masterModelId' : 'airlineId'

      this.tableItems.forEach(parent => {
        if (parent.checked) {
          parent.items.forEach(child => {
            if (child.checked) {
              const tableItem = {
                [parentId]: parent.value,
                [childId]: child.value,
              }
              items.push(tableItem)
            }
          })
        }
      })

      return items
    },

    getListFilterStatus(items) {
      if (
        !this.isEverythingChecked(items) &&
        !this.isEverythingUnchecked(items)
      ) {
        return 2
      }
      if (this.isEverythingUnchecked(items)) {
        return 0
      }
      if (this.isEverythingChecked(items)) {
        return 1
      }
      return 0
    },
  },
}
</script>
